<template>
  <div class="top">
    <div class="logo-img" :style="logoImg"></div>
    <div class="job-btn">
      <router-link :to="$route.path == '/Job/JobDetail' ? '/Job' : '/'"
      v-if="$route.path !== '/'" class="apply-job-btn">{{$route.path == '/Job/JobDetail' ? '后退' : '返回首页'}}</router-link>
      <router-link to="Job" class="apply-job-btn" v-else>申请职位</router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logoImg: `background: url(${process.env.BASE_URL}ImgFiles/whcj-zp.png) no-repeat center/auto; background-size: contain;`,
    }
  },
};
</script>

<style scoped>
.top {
  width: 100%;
  height: 2.52rem;
  border-bottom: 1px rgb(195, 195, 195) solid;
  position: fixed;
  padding: 0 0.577rem;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  z-index: 99;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo-img {
  width: 6.5rem;
  /* position: absolute; */
  height: 2.016rem;
}
.job-btn {
  width: 2.848rem;
  height: 1.1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #6d80cb;
  text-align: center;
  border-radius: 0.17rem;
}
.apply-job-btn {
  color: #fff;
  font-size: 0.58rem;
  text-decoration: none;
  font-weight: bold;
}
.back-home {
  width: 2.37rem;
  border: 1px rgb(145, 145, 145) solid;
  border-radius: 0.17rem;
  color: rgb(107, 107, 107);
  font-size: 0.508rem;
  position: absolute;
  right: 0.34rem;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  text-decoration: none;
  padding: 0.08rem 0.13rem;
  text-align: center;
}
</style>